import { Image, Info } from 'components';

export default function FunctionInfo(props: InfoProps) {

    return <Info {...props}>
        <Image alt="Person holding a calculator in front of them" path="function.png" title="Function" />
        <h5>Function</h5>
        <p>
            This is an advanced feature that changes how the <span className="fst-italic">Margin of Error</span> is calculated.
            <br />
            <br />
            You can manually select whether the calculator uses the Z-Test or T-Test to determine the <span className="fst-italic">Margin of Error</span>. When set to Automatic, the calculator will use the Z-Test at sample sizes &lt;=30 and otherwise uses the T-Test.
            <br />
            <br />
            <span className="text-error">Note</span>: If you&apos;re not sure what this means, keep this set to Automatic.
        </p>
    </Info>;

}